import { passportCredSearchFilterName } from './PassportCredFilterUtility';

export interface IPassportCredSelectedFilters {
  [passportCredSearchFilterName.status]?: string[];
  [passportCredSearchFilterName.category]?: string[];
}

export const defaultPassportCredFilters: IPassportCredSelectedFilters = {
  status: [],
  categories: [],
};
